<template>
  <div id="container"  class="mainBox">
    <nyTit  pathUrl='/nongye1' />
    <h5 class="h5">以市场为导向&nbsp&nbsp&nbsp调结构优品质</h5>
  <!-- 顶部 -->
  <!-- 左边 -->
    <div class="content">
      <div class="left flex_column">
        <div class="subTit1"><span>全国小麦及面粉相关数据分析</span></div>
<!--        左一-->
        <div class="leftBox1">
          <div class="leftBox_item flex_column">
            <div class="subTit2"><span>全国小麦主要品种分布情况</span></div>
            <div class="leftTopInfo">
              <div class="echarts" v-for="(item,index) in state.left_data1" :key="index">
                <LeftPie :listData="item" />
              </div>
            </div>
          </div>
          <div class="leftBox_item flex_column">
            <div class="subTit2"><span>全国面粉主要品种分布</span></div>
            <div class="leftTopInfo">
              <div class="echarts" v-for="(item,index) in state.left_data2" :key="index">
                <LeftPie :listData="item" />
              </div>
            </div>
          </div>
        </div>
        <!--        左二-->
        <div class="leftBox2">
          <div class="leftBox_item flex_column">
            <div class="subTit2"><span>全国小麦品种价格走势(元/斤)</span></div>
            <div class="echartsBox"><LeftLine  :listData="state.left_data3"/></div>
          </div>
          <div class="leftBox_item flex_column">
            <div class="subTit2"><span>全国面粉品种价格走势(元/斤)</span></div>
            <div class="echartsBox"><LeftLine  :listData="state.left_data4"/></div>
          </div>
        </div>
            <!--        左三-->
        <div class="leftBox3">
          <div class="leftBox_item flex_column">
            <div class="subTit2"><span>全国小麦主要品种供需关系</span></div>
            <div class="echartsBox"><LeftLine2  :listData="state.left_data5"/></div>
          </div>
          <div class="leftBox_item flex_column">
            <div class="subTit2"><span>全国面粉主要品种供需关系</span></div>
            <div class="echartsBox"><LeftLine3  :listData="state.left_data6"/></div>
          </div>
        </div>

      </div>
      <!--  中间-->
      <div class="center flex_column">
        <div class="subTit1"><span> 近三年上蔡县小麦及其面粉产业数据分析</span></div>
        <div class="centerInfo">
          <div class="center_l flex_column">
            <div class="center_l_A flex_column">
              <div class="subTit2"><span>上蔡县小麦种植及产量情况</span></div>
              <div class="center_l_A_info">
                <div class="center_l_A_item flex_column" v-for="(item,index) in state.centerData1" :key="index">
                  <div class="name">{{item.name}}<span v-if="item.subName">{{item.subName}}</span></div>
                  <div class="txt">{{item.txt1}}</div>
                  <div class="txt">{{item.txt2}}</div>
                </div>
              </div>
            </div>
            <div class="center_l_B flex_column">
              <div class="subTit2"><span>上蔡县小麦深加工及仓储情况</span></div>
              <div class="center_l_B_info">
                <div class="center_l_B_item flex_column" v-for="(item,index) in state.centerData2">
                  <h5>{{item.name}}</h5>
                  <div class="item" v-for="(item0,index0) in item.list" :key="index0">
                    <span>{{item0.name}}</span><span>{{item0.value}}{{item0.unit}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="center_l_C">
              <div class="subTit2"><span>上蔡县小麦育种情况</span></div>
              <div class="center_l_C_info">
                <div class="txt1Box">
                  <div class="txt1Item" v-for="(item,index) in state.centerTxt1" :key="index">{{item}}</div>
                </div>
                <div class="txt2Box">
                  <div class="txt2Item" v-for="(item,index) in state.centerTxt2" :key="index"><span>{{item.title}}</span><span>{{item.txt}}</span></div>
                </div>
                <div class="txt1Box">
                  <div class="txt1Item" v-for="(item,index) in state.centerTxt3" :key="index">{{item}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="center_r flex_column">
            <div class="center_r_A flex_column">
              <div class="subTit2"><span>近三年上蔡县农特产品加工企业各类面粉需求情况</span></div>
              <div class="echartsBox"><CenterBar :listData="state.centerbar" /></div>
            </div>
            <div class="center_r_B flex_column">
              <div class="subTit2"><span>未来三年上蔡县优质小麦产业发展规划</span></div>
              <div class="center_r_B_info flex_column">
                <div class="info2">
                  <div class="info2Item" v-for="(item,index) in state.rightData2">
                    <img :src="item.icon" />
                    <span>{{item.txt}}</span>
                  </div>
                </div>
                <div class="info1">
                  <div class="info1Item" v-for="(item,index) in state.rightData1">
                    <div class="imgBox"><img src="../assets/img/xiaomai/h.png" v-if="index==3" /><img src="../assets/img/xiaomai/wl.png" v-else /><span>{{item.value}}</span></div>
                    <span class="txt">{{item.name}}<i>{{item.subName}}</i></span>
                  </div>
                </div>
<!--                <div class="info3">{{state.righttxt}}</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right flex_column">
        <div class="subTit1"><span>智能种植模型</span></div>
        <div class="rightInfo">
          <div class="right_l flex_column">
            <div class="subTit2"><span>种植模型数据采集</span></div>
            <div class="t_down">
              <div class="t_d_t">
                <div class="t_d_t_jz">
                  <span></span>
                  <h6>选择区域：</h6>
                  <div class="srk">河南省驻马店市上蔡县</div>
                </div>
              </div>
              <div class="t_d_b">
                <div class="t_d_t_jz">
                  <span></span>
                  <h6>选择分类：</h6>
                  <div class="srk">小麦</div>
                </div>
              </div>
              <div class="t_d_d">
                <div class="t_d_t_jz">
                  <span></span>
                  <h6>选择品类：</h6>
                  <div class="srk">存麦一号</div>
                </div>
              </div>
              <div class="t_d_d1">
                <div class="t_d_d1_l">
                  <h5>地块管理</h5>
                  <div class="d1_xtb"></div>
                </div>
                <div class="t_d_d1_r" @click="clickFangan()">
                  <h5>生成方案</h5>
                  <div class="d1_xtb"></div>
                </div>
              </div>
            </div>
            <div class="t_bottom">
              <div class="t_bottom_item" v-for="(item,index) in state.rightVideo" @click="videoClick(index)"><img :src="item.img"/> </div>
            </div>
          </div>
          <div class="right_r flex_column">
            <div class="subTit2"><span>种植数据方案</span></div>
            <div class="right_r_box1 flex_column">
              <div class="l_t_d_m">
                <div
                  class="l_t_d_m_g"
                  :class="{ l_t_d_m_g_cur: state.right_r_dataCur == index }"
                  v-for="(item, index) in state.right_r_data"
                  :key="index"
                  @click="leftTab1(index)"
                >
                  {{ item.name }}
                </div>
                <!-- <div class="l_t_d_m_g">生长记录</div>
              <div class="l_t_d_m_g">种植方案</div> -->
              </div>
              <div class="scrollTable">
                <dv-scroll-board
                  :config="state.right_r_data[state.right_r_dataCur].config"
                  style="width: 100%; height: 100%"
                />
              </div>
            </div>
            <div class="right_r_box2 flex_column">
              <div class="right_r_box2_item1">
                <h4>模型结论</h4>
                <div class="txt1" v-html="state.right_r_data2"></div>
              </div>
              <div class="right_r_box2_item2 flex_column">
                <h4>专家建议</h4>
                <div class="txt2"><span v-for="(item,index) in state.right_r_data3" :key="index">{{item}}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
       </div>
  </div>
<!-- <footer1 />-->
  <!-- 方案 -->
  <div class="popBg animate__animated animate__zoomIn" @click.stop="hiddlen" v-if="state.faSHow">
    <div class="faCon" @click.stop="hiddlen1">
      <div class="close" @click.stop="hiddlen">×</div>
      <div class="faInfo">
        <dv-scroll-board :config="state.config" style="width: 100%; height: 100%"/>
      </div>
    </div>
  </div>
  <popBg v-if="state.popShow" :title="state.rightVideo[state.curVideoIndex].name" :code="state.rightVideo[state.curVideoIndex].code" :popShow="state.popShow" @hiddlen="popHiddlen">
    <div style=" width: 100%;height: 100%" >
      <iframe
        :src="state.rightVideo[state.curVideoIndex].options.src+state.AccessToken"
        width="100%"
        height="100%"
        id="ysOpenDevice"
        allowfullscreen
      >
      </iframe>
    </div>
  </popBg>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";


import nyTit from '@/components/nyTit'
import navItem from '@/components/nyNav'
import footer1 from "@/components/footer.vue";

import LeftPie from "@/components/xiaomai/LeftPie.vue"
import LeftLine from "@/components/xiaomai/LeftLine.vue"
import LeftLine2 from "@/components/xiaomai/leftline2.vue"
import LeftLine3 from "@/components/xiaomai/leftline3.vue"
import CenterBar from "@/components/xiaomai/centerBar.vue"
import popBg from "@/components/popBg.vue";
    // const timer = ref(null);
const router = useRouter();
const mapRef = ref(null);
const activeName = ref(0)
const state = reactive({
  left_data1:[
    {
      name:"售卖",
      list:[
        {value: 34.3, name: "白麦", },
        {value: 22.8, name: "碎麦", },
        {value: 14.2, name: "黑麦", },
        {value: 11.8, name: "麦仁", },
        {value: 8.7, name: "红麦", },
        {value: 8.2, name: "其他", },
      ]
    },
    {
      name:"采购",
      list:[
        {value: 35.5, name: "白麦", },
        {value: 16.4, name: "碎麦", },
        {value: 12.6, name: "红麦", },
        {value: 9.3, name: "麦仁", },
        {value: 8, name: "黑麦", },
        {value: 18.2, name: "其他", },
      ]
    },
  ],
  left_data2:[
    {
      name:"售卖",
      list:[
        {value: 44.6, name: "小麦粉", },
        {value: 12.5, name: "次粉", },
        {value: 10.5, name: "面筋粉", },
        {value: 9.1, name: "全麦粉", },
        {value: 4.8, name: "自发粉", },
        {value: 18.5, name: "其他", },
      ]
    },
    {
      name:"采购",
      list:[
        {value: 43.2, name: "小麦粉", },
        {value: 16.4, name: "次粉", },
        {value: 8.7, name: "面筋粉", },
        {value: 7.7, name: "全麦粉", },
        {value: 5.8, name: "黑小麦面粉", },
        {value: 18.2, name: "其他", },
      ]
    },
  ],
  left_data3:{
    xData: [2025.1,2025.2,2025.3,2025.4,2025.5,2025.6,2025.7,2025.8,2025.9,2025.10,2025.11,2026.1,2026.2,2026.3],
    lineData: [
      {
        name: '白麦',
        data: [
          {value: 1.62, symbol: 'circle', symbolSize: 10},
          {value: 1.63, symbol: 'circle', symbolSize: 0},
          {value: 1.62, symbol: 'circle', symbolSize: 10},
          {value: 1.61, symbol: 'circle', symbolSize: 0},
          {value: 1.56, symbol: 'circle', symbolSize: 10},
          {value: 1.55, symbol: 'circle', symbolSize: 0},
          {value: 1.53, symbol: 'circle', symbolSize: 0},
          {value: 1.74, symbol: 'circle', symbolSize: 0},
          {value: 1.53, symbol: 'circle', symbolSize: 10},
          {value: 1.65, symbol: 'circle', symbolSize: 0},
          {value: 1.55, symbol: 'circle', symbolSize: 10},
          {value: 1.59, symbol: 'circle', symbolSize: 0},
          {value: 1.58, symbol: 'circle', symbolSize: 10},
          {value: 1.58, symbol: 'circle', symbolSize: 0},
        ]
      },
      {
        name: '碎麦',
        data: [
          {value: 0.67, symbol: 'circle', symbolSize: 10},
          {value: 0.68, symbol: 'circle', symbolSize: 0},
          {value: 0.69, symbol: 'circle', symbolSize: 10},
          {value: 0.68, symbol: 'circle', symbolSize: 0},
          {value: 0.72, symbol: 'circle', symbolSize: 10},
          {value: 0.75, symbol: 'circle', symbolSize: 0},
          {value: 2.88, symbol: 'circle', symbolSize: 0},
          {value: 0.71, symbol: 'circle', symbolSize: 0},
          {value: 0.75, symbol: 'circle', symbolSize: 10},
          {value: 0.77, symbol: 'circle', symbolSize: 0},
          {value: 0.74, symbol: 'circle', symbolSize: 10},
          {value: 0.77, symbol: 'circle', symbolSize: 0},
          {value: 0.73, symbol: 'circle', symbolSize: 10},
          {value: 0.73, symbol: 'circle', symbolSize: 0},
        ]
      },
      {
        name: '黑麦',
        data: [
          {value: 5.12, symbol: 'circle', symbolSize: 10},
          {value: 5.01, symbol: 'circle', symbolSize: 0},
          {value: 4.6, symbol: 'circle', symbolSize: 10},
          {value: 4.35, symbol: 'circle', symbolSize: 0},
          {value: 4.46, symbol: 'circle', symbolSize: 10},
          {value: 4.5, symbol: 'circle', symbolSize: 0},
          {value: 1.4, symbol: 'circle', symbolSize: 0},
          {value: 4.85, symbol: 'circle', symbolSize: 0},
          {value: 4.82, symbol: 'circle', symbolSize: 10},
          {value: 4.67, symbol: 'circle', symbolSize: 0},
          {value: 4.63, symbol: 'circle', symbolSize: 10},
          {value: 2.83, symbol: 'circle', symbolSize: 0},
          {value: 2.87, symbol: 'circle', symbolSize: 10},
          {value: 2.88, symbol: 'circle', symbolSize: 0},
        ]
      },
      {
        name: '麦仁',
        data:  [
          {value: 7.22, symbol: 'circle', symbolSize: 10},
          {value: 5.02, symbol: 'circle', symbolSize: 0},
          {value: 2.41, symbol: 'circle', symbolSize: 10},
          {value: 2.36, symbol: 'circle', symbolSize: 0},
          {value: 2.54, symbol: 'circle', symbolSize: 10},
          {value: 2.04, symbol: 'circle', symbolSize: 0},
          {value: 1.35, symbol: 'circle', symbolSize: 0},
          {value: 1.88, symbol: 'circle', symbolSize: 0},
          {value: 1.82, symbol: 'circle', symbolSize: 10},
          {value: 1.82, symbol: 'circle', symbolSize: 0},
          {value: 1.82, symbol: 'circle', symbolSize: 10},
          {value: 1.85, symbol: 'circle', symbolSize: 0},
          {value: 1.88, symbol: 'circle', symbolSize: 10},
          {value: 1.85, symbol: 'circle', symbolSize: 0},
        ]
          // [7.22, 5.02, 2.41, 2.36, 2.54, 2.04, 1.35,1.88,1.82,1.82,1.82,1.85,1.88,1.85],
      },
      {
        name: '红麦',
        data:[
          {value: 1.72, symbol: 'circle', symbolSize: 10},
          {value: 1.74, symbol: 'circle', symbolSize: 0},
          {value: 1.75, symbol: 'circle', symbolSize: 10},
          {value: 1.85, symbol: 'circle', symbolSize: 0},
          {value: 1.73, symbol: 'circle', symbolSize: 10},
          {value: 1.75, symbol: 'circle', symbolSize: 0},
          {value: 1.44, symbol: 'circle', symbolSize: 0},
          {value: 1.93, symbol: 'circle', symbolSize: 0},
          {value: 1.95, symbol: 'circle', symbolSize: 10},
          {value: 1.92, symbol: 'circle', symbolSize: 0},
          {value: 1.93, symbol: 'circle', symbolSize: 10},
          {value: 1.71, symbol: 'circle', symbolSize: 0},
          {value: 2, symbol: 'circle', symbolSize: 10},
          {value: 1.97, symbol: 'circle', symbolSize: 0},
      ]
          // [1.72, 1.74, 1.75, 1.85,1.73, 1.75, 1.44,1.93,1.95,1.92,1.93,1.71,2,1.97],
      },
    ]
  },
  left_data4:{
    xData: [2025.1,2025.2,2025.3,2025.4,2025.5,2025.6,2025.7,2025.8,2025.9,2025.10,2025.11,2026.1,2026.2,2026.3],
    lineData: [
      {
        name: '小麦粉',
        data: [
          {value: 3.42, symbol: 'circle', symbolSize: 10},
          {value: 3.49, symbol: 'circle', symbolSize: 0},
          {value: 3.54, symbol: 'circle', symbolSize: 10},
          {value: 3.51, symbol: 'circle', symbolSize: 0},
          {value: 3.56, symbol: 'circle', symbolSize: 10},
          {value: 3.57, symbol: 'circle', symbolSize: 0},
          {value: 3.53, symbol: 'circle', symbolSize: 0},
          {value: 3.39, symbol: 'circle', symbolSize: 0},
          {value: 3.59, symbol: 'circle', symbolSize: 10},
          {value: 3.47, symbol: 'circle', symbolSize: 0},
          {value: 3.63, symbol: 'circle', symbolSize: 10},
          {value: 3.64, symbol: 'circle', symbolSize: 0},
          {value: 3.69, symbol: 'circle', symbolSize: 10},
          {value: 3.64, symbol: 'circle', symbolSize: 0},
        ]
      },
      {
        name: '次粉',
        data: [
          {value: 1.2, symbol: 'circle', symbolSize: 10},
          {value: 1.19, symbol: 'circle', symbolSize: 0},
          {value: 1.2, symbol: 'circle', symbolSize: 10},
          {value: 1.22, symbol: 'circle', symbolSize: 0},
          {value: 1.19, symbol: 'circle', symbolSize: 10},
          {value: 1.16, symbol: 'circle', symbolSize: 0},
          {value: 1.13, symbol: 'circle', symbolSize: 0},
          {value: 1.12, symbol: 'circle', symbolSize: 0},
          {value: 1.13, symbol: 'circle', symbolSize: 10},
          {value: 1.1, symbol: 'circle', symbolSize: 0},
          {value: 1.07, symbol: 'circle', symbolSize: 10},
          {value: 1.07, symbol: 'circle', symbolSize: 0},
          {value: 1.07, symbol: 'circle', symbolSize: 10},
          {value: 1.07, symbol: 'circle', symbolSize: 0},
        ]
      },
      {
        name: '面筋粉',
        data: [
          {value: 4.44, symbol: 'circle', symbolSize: 10},
          {value: 4.69, symbol: 'circle', symbolSize: 0},
          {value: 4.56, symbol: 'circle', symbolSize: 10},
          {value: 4.66, symbol: 'circle', symbolSize: 0},
          {value: 5.09, symbol: 'circle', symbolSize: 10},
          {value: 5.16, symbol: 'circle', symbolSize: 0},
          {value: 4.98, symbol: 'circle', symbolSize: 0},
          {value: 4.85, symbol: 'circle', symbolSize: 0},
          {value: 4.84, symbol: 'circle', symbolSize: 10},
          {value: 4.83, symbol: 'circle', symbolSize: 0},
          {value: 4.91, symbol: 'circle', symbolSize: 10},
          {value: 4.57, symbol: 'circle', symbolSize: 0},
          {value: 3.38, symbol: 'circle', symbolSize: 10},
          {value: 3.38, symbol: 'circle', symbolSize: 0},
        ]
      },
      {
        name: '全麦粉',
        data:  [
          {value: 5.03, symbol: 'circle', symbolSize: 10},
          {value: 3.89, symbol: 'circle', symbolSize: 0},
          {value: 3.79, symbol: 'circle', symbolSize: 10},
          {value: 3.07, symbol: 'circle', symbolSize: 0},
          {value: 3.65, symbol: 'circle', symbolSize: 10},
          {value: 3.74, symbol: 'circle', symbolSize: 0},
          {value: 4.32, symbol: 'circle', symbolSize: 0},
          {value: 5.03, symbol: 'circle', symbolSize: 0},
          {value: 4.64, symbol: 'circle', symbolSize: 10},
          {value: 5.01, symbol: 'circle', symbolSize: 0},
          {value: 5.19, symbol: 'circle', symbolSize: 10},
          {value: 5.34, symbol: 'circle', symbolSize: 0},
          {value: 4.98, symbol: 'circle', symbolSize: 10},
          {value: 5.35, symbol: 'circle', symbolSize: 0},
        ]
      },
      {
        name: '自发粉',
        data:[
          {value: 7.65, symbol: 'circle', symbolSize: 10},
          {value: 7.65, symbol: 'circle', symbolSize: 0},
          {value: 7.65, symbol: 'circle', symbolSize: 10},
          {value: 7.11, symbol: 'circle', symbolSize: 0},
          {value: 7.07, symbol: 'circle', symbolSize: 10},
          {value: 7.06, symbol: 'circle', symbolSize: 0},
          {value: 7.72, symbol: 'circle', symbolSize: 0},
          {value:7.34, symbol: 'circle', symbolSize: 0},
          {value: 7.4, symbol: 'circle', symbolSize: 10},
          {value: 7.38, symbol: 'circle', symbolSize: 0},
          {value: 7.73, symbol: 'circle', symbolSize: 10},
          {value: 3, symbol: 'circle', symbolSize: 0},
          {value:5.05, symbol: 'circle', symbolSize: 10},
          {value: 3, symbol: 'circle', symbolSize: 0},
        ]
      },
    ]
  },
  left_data5:{
    // xLabel:["青麦", "富硒小麦", "小麦胚芽", "红麦", "麦仁", "黑麦", "碎麦", "白麦"],
    xLabel:["白麦", "碎麦", "黑麦", "麦仁", "红麦"],
   goToSchool: [ "0", "0", "0", "1.3","2.5"],
    goOutSchool: [ "0.999", "0.999", "0.999", "0.999", "0.999"],
    goOutSchool1: [ "0.6", "0.6", "0.8", "0","0"],
  },
  left_data6:{
    xLabel:[ "小麦粉", "次粉", "面筋粉", "全麦粉", "自发粉","黑小麦粉"],
    goToSchool: [ "0", "1.4","0","1.9","0","2"],
    goOutSchool: [ "0.999", "0.999", "0.999", "0.999", "0.999", "0.999"],
    goOutSchool1: [ "0.9", "0","0.6","0","0.3","0"],
  },
  centerData1:[
    {name:"中筋小麦",txt1:"种植面积67万亩",txt2:"产量36.3万吨"},
    {name:"高筋小麦",txt1:"种植面积85万亩",txt2:"产量46.4万吨"},
    {name:"专用小麦",subName:"(黑小麦、绿小麦)",txt1:"种植面积9000亩",txt2:"产量5850吨"}
  ],
  centerData2:[
    {name:"小麦深加工",list:[{name:"加工企业",value:8,unit:"家"},{name:"加工能力",value:52,unit:"万吨"}]},
    {name:"面粉深加工",list:[{name:"加工企业",value:12,unit:"家"},{name:"加工能力",value:1.8,unit:"万吨"}]},
    {name:"小麦收储",list:[{name:"收储企业",value:26,unit:"家"},{name:"仓容能力",value:39,unit:"万吨"}]}
  ],
  centerTxt1:["上蔡县共有民办非企业育种单位2个，分别是上蔡县创新农业科学技术研究开发中心和上蔡县亿麦轩小麦研究所。","2018-2023年共有6个小麦新品种获得了国家和省级审定"],
  centerTxt2:[{title:"通过国家审定：",txt:"“轮选禧麦1号” "},{title:"通过河南省审定：",txt:"“轮选88”“ 轮选122”“轮选125” “轮选130”“戚丰5号” "}],
  centerTxt3:["10个品系正在参加国家和省试验","“十四五”期间，将有三个小麦新品种分别通过国家和省级审定。 "],
  centerbar:{
    time:['2023', '2024', '2025'],
    list:[
      {
        name: '强筋',
        value: [4820, 5300, 5960]
      },
      {
        name: '中筋',
        value: [4600, 4940, 5720]
      },
      {
        name: '弱筋',
        value: [6320, 7040, 7600],
      },
      {
        name: '专用面粉（绿小麦、黑小麦）',
        value: [3860, 4180, 4600],
      },
    ]
  },
  rightData1:[
    {name:"强筋小麦种植(万亩)",value:'90'},
    {name:"中筋小麦种植(万亩)",value:'59'},
    // {name:"弱筋小麦种植",value:'XX'},
    {name:"专用小麦(万亩)",subName:" （绿小麦、黑小麦）",value:'3'},
    {name:"新增面粉深加工能力（万吨）",subName:"",value:'2'},
  ],
  rightData2:[
    {txt:"引进院士工作站1个",icon:require('../assets/img/xiaomai/yj.png'),color:"#53EA8C"},
    {txt:"培育优质小麦新品种2个",icon:require('../assets/img/xiaomai/L.png'),color:"#F5E81C"},
  ],
  // righttxt:"预计小麦产业整体增收XX%。",
  faSHow: false,
  config: {
    header: [
      '<span style="color:#fff;">农情</span>',
      '<span style="color:#fff;">项目</span>',
      '<span style="color:#fff;">记录</span>',
    ],

    data: [
      [
        "10-25",
        "物资准备",
        "物资准备",
      ],
      [
        "10-26",
        "精细整地",
        "施肥、犁地、旋地",
      ],
      [
        "10-27",
        "底肥撒施",
        "尿素:8.7kg/亩;二铵:10.0kg/亩;硫酸钾:2.6kg/亩或尿素:8.7kg/亩;二铵:10.0kg/亩;氯化钾:2.4kg/亩",
      ],
      [
        "11-15",
        "播种",
        "用穴播机播种，机具运行速度要中等匀速，行间距保持一致，确保每穴下籽量基本相同，每亩地播种30斤左右小麦种子",
      ],
      ["11-15", "补苗 ", "如遇到小麦出苗率低的地方，建议补苗。"],
      [
        "03-05",
        "苗后除草",
        "化学除草宜选择在小麦3~5期、杂草2~4叶期、日平均气温在6℃以上的晴天进行，可选用甲基二磺隆防除节节麦、蔄草、硬草，选用啶磺草胺氟唑磺隆防除雀麦，选用唑啉草酯、炔草酯防除野燕麦、日本看麦娘、看麦娘，选用双氟磺草胺、2甲4钠、氟氧乙酸唑草酮或双唑草酮防除播娘蒿、猪殃殃、婆婆纳、牛繁缕等阔叶杂草。",
      ],
      ["03-05", "浇水", "看土地墒情"],
      [
        "04-15",
        "打药",
        "抽穗扬花期，这个时期小麦处于见花打药的状态。以预防小麦赤霉病为主，兼顾条锈病、白粉病、蚜虫以及其他咀嚼式害虫。防治药剂：可选用氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（啶虫脒、吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素、赤·吲乙·芸苔）。可合理选用叶面肥（植物动力2003、保势腾、美座），混合喷施。",
      ],
      [
        "05-05",
        "打药",
        "灌浆成熟期，这个时期小麦处于抽穗至灌浆期，重点防控小麦穗蚜、条锈病，预防赤霉病，预防干热风、抗旱、抗倒伏，兼顾其他咀嚼式害虫。防治药剂：可选用氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素内酯）。可合理添加叶面肥（植物动力2003、保势腾、美座）喷施，实现“一喷多防”。",
      ],
      [
        "06-01",
        "收获 ",
        "810公斤/亩，小麦成熟，收割入仓。",
      ],
    ],
    headerBGC: "#15364D",
    oddRowBGC: "",
    evenRowBGC: "",
    index: false,
    columnWidth: [200, 200],
    align: ["center", "center", "left"],
    rowNum: 12,

  },
  rightVideo:[
    {
      name:"黄埠镇",
      // name:"上蔡农业局01",
      img:require("../assets/img/xiaomai/img1.jpg"),
      type:1,
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538489/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"AZ8538489"
    },
    {
      // name:"上蔡农业局02",
      name:"无量寺乡",
      img:require("../assets/img/xiaomai/img2.jpg"),
      type:1,
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538131/2.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"AZ8538131"
    },
    {
      // name:"上蔡农业局02",
      name:"塔桥镇",
      img:require("../assets/img/xiaomai/img3.jpg"),
      type:1,
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538131/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"AZ8538131"
    },
    {
      // name:"上蔡农业局02",
      name:"崇礼乡",
      img:require("../assets/img/xiaomai/img4.jpg"),
      type:1,
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502097/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      code:"FB2502097"
    }
  ],
  popShow:false,
  curVideoIndex:0,
  AccessToken:"",
  right_r_data: [
    {
      name: "生长记录",
      config: {
        header: [
          '<span style="color:#fff;">农情</span>',
          '<span style="color:#fff;">项目</span>',
          '<span style="color:#fff;">记录</span>',
        ],

        data: [
          ["10-17", "播种环节农机服务", "灭茬45元/亩/次 1次 撒有机肥35元/亩/次 1次  深耕40元/亩/次 1次  旋地35元/亩/次 2次   种肥同播50元/亩/次 1次  震压10元/亩/次  1次"],
          ["10-21", "施肥", " 澳佳微生物肥 2500元/吨 70kg/亩  ETS菌肥1158元/吨 澳佳13-18-15 t3950元/吨 t120斤/亩 骏华25-13-7 3850元/吨 100斤/亩 鲁西15-15-15 3980元/吨 100斤/亩"],
          ["10-21", "播种", "天宁38 3.6元/斤 40斤/亩 新麦45 3.6元"],
          ["11-05", "蒙头水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
          "\t80元/亩\t1次\n" +
          "平移式喷灌\t\t2次"],
          ["02-04", "越冬水灌溉", "骏华第十六元素\\t2850元/吨\\t30斤/亩\\n澳佳乌金氮\\t3050元/吨\\t30斤/亩\\n播肥机\\t12元/亩\\t1次"],
          ["02-27", "打药", "\"药品1：美丰麦笑（双氟·氯氟吡）+锐耙（2甲4氯钠）+亨达超克（联苯·噻虫嗪）\n" +
          "药品2：酷佬（2甲·双氟·唑）+闪净（联菊·啶虫脒）+恋神奇（碳机硅）\"\n" +
          "多花黑麦草除草剂：美丰瑞丰年（20%甲基二磺隆·异丙隆）+美丰无止境（哗咻草醋）\n" +
          "除草剂、杀虫剂\t12元/亩\t1次\n" +
          "机械\t8元/亩\t\n" +
          "多花黑麦草\t50元/亩\t1次\n" +
          "机械\t8元/亩\t"],
          ["03-09", "打药", "\"药品1：利尔作物·独功（氯氟·毒死蜱）+乐奥多·微量元素水溶肥料+利尔作物·普伴（24-表芸苔素内脂）+赛都优（氨基寡糖素）\n" +
          "药品2：六夫丁·快守（高效氯氟氰菊酯）+澳佳·活力丰（腐殖酸钾）+佳运（24-表芸苔素内脂）+优植康·清辞（寡糖·吗胍）\"\n" +
          "一喷三防\t18元/亩/次\t1次"],
          ["03-14", "返青水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
          "\t80元/亩\t1次\n" +
          "平移式喷灌\t\t2次"],

        ],
        headerBGC: "#274547",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        columnWidth: [200, 200],
        align: ["center", "center", "center"],
        // rowNum:6
      },
    },
    {
      name: "种植方案",
      config: {
        header: [
          '<span style="color:#fff;">日期</span>',
          '<span style="color:#fff;">农事</span>',
          '<span style="color:#fff;">具体操作</span>',
        ],
        data: [
          ["6-21", "追肥", "施用叶面肥1683亩"],
          ["7-21", "化控", "植保无人机一喷三防共3493亩"],
          ["8-01", "收获", "收获1452亩"],
          ["9-21", "追肥", "施用复合肥426亩"],
          ["11-21", "底肥撒施", "施用复合肥1118亩"],
          ["11-26", "追肥", "施用叶面肥1683亩"],
          ["11-30", "化控", "植保无人机一喷三防共3493亩"],
          ["12-21", "收获", "收获1452亩"],
          ["12-21", "追肥", "施用复合肥426亩"],
          ["12-21", "底肥撒施", "施用复合肥1118亩"],
        ],
        headerBGC: "#274547",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        // columnWidth: [100, 100],
        align: ["center", "center", "center"],
        rowNum:6
      },
    },
  ],
  right_r_dataCur: 0,
  right_r_data2:"小麦的生长期需要根据播种的时间而定，通常小麦从播种到成熟，生长周期在220~270天左右，再加上各地的天气情况都有所不同，因此小麦具体要生长多久需要根据实际情况而定。",
  right_r_data3:["一、选择合适的种植时间","二、合理的使用施肥","三、做好病虫害防治工作","四、注意细节，提高产量"]
});
function leftTab1(index) {
  state.right_r_dataCur = index;
}
function videoClick(index1){
  console.log(index1)
  state.popShow = true
  state.curVideoIndex = index1
}
function popHiddlen(){
  state.popShow = false
}
  function hiddlen() {
    state.faSHow = false;
  }
  function clickFangan(type) {
    state.faSHow = true;
  }

    // 在 onMounted 中初始化地图
    onMounted(() => {

    });


    onMounted(() => {
      state.AccessToken = localStorage.getItem('AccessToken')
    });
    onUnmounted(() => {
     
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
.flex_column {
  display: flex;
  flex-direction: column;
}
.h5{
  position: absolute;
  top: 130px;
  left: 140px;
  z-index: 999;
  font-size: 40px;
  color:#F3FCFF;
  letter-spacing: 5px;
  text-align: left;
  //text-shadow: 5px 0px 5px rgba(13, 89, 82, .9)
  text-shadow:
    0 0 5px rgba(21, 241, 187, 0.5), /* 第一层内发光 */
    0 0 10px rgba(21, 241, 187, 0.8), /* 第二层内发光 */
    0 0 20px rgba(21, 241, 187, 1);   /* 第三层内发光 */
}
.mainBox {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  display: flex;
  .content {
    width: 100%;
    height: calc(100% - 100px);
    position: absolute;
    top: 100px;
    // border: #fff 1px solid;
    display: flex;
    padding: 0 30px 100px;
    .subTit1{
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/bt.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;
      span{
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;


      }
    }
    .subTit2{
      width: 100%;
      height: 66px;
      line-height: 20px;
      padding-left: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png") no-repeat left bottom;
      font-size: 30px;
      text-align: left;
      color: rgba(254,254,254,1);
    }
    .echartsBox {
      width: 100%;
      flex: 1;
    }
    .center{
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 80px;
      .centerInfo{
        width: 100%;
        flex: 1;
        display: flex;
        .center_l{
          width: 1034px;
          height: 100%;
          //border: 1px solid;
          .center_l_A{
            width: 100%;
            height:360px ;
            .center_l_A_info{
              width: 100%;
              flex: 1;
              display: flex;
              justify-content: space-between;
              padding: 20px;
              .center_l_A_item{
                .name{
                  width: 248px;
                  height: 98px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  padding-left: 100px;
                  text-align: left;
                  font-size: 26px;
                  color: #fff;
                  background: url("../assets/img/xiaomai/qj.png") no-repeat;
                  span{font-size: 18px}
                }
                .txt{
                  width: 253px;
                  height: 61px;
                  color: #fff;
                  font-size: 26px;
                  text-align: center;
                  line-height: 61px;
                  background: url("../assets/img/xiaomai/zz.png") no-repeat;
                  margin: 5px 0;
                }
              }
            }
          }
          .center_l_B{
            width: 100%;
            height:255px ;
            .center_l_B_info{
              width: 100%;
              flex: 1;
              display: flex;
              justify-content: space-between;
              padding: 0 30px;
              .center_l_B_item{
                width: 279px;
                height: 157px;
                background: url("../assets/img/xiaomai/sjg.png") no-repeat;
                text-align: left;
                justify-content: center;
                h5{
                  font-size: 28px;
                  color: #9EFAF5;
                  font-weight: bold;
                  padding-left: 26px;
                }
                .item{
                  line-height: 30px;
                  font-size: 24px;
                  display: flex;
                  justify-content: space-between;
                  padding:0 0 0 44px;
                  line-height: 40px;
                  span{
                    display: block;
                    color: #fff;
                  }
                  span:first-child{color:#9EFAF5 }
                }
              }
            }
          }
          .center_l_C{
            width: 100%;
            flex: 1;
            margin-top: 10px;
            .center_l_C_info{
              padding: 20px 30px 0 18px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .txt1Box{
                .txt1Item{
                  background: url("../assets/img/xiaomai/scx.png") no-repeat left 10px;
                  padding-left: 40px;
                  color: #fff;
                  font-size: 30px;
                  margin-bottom: 30px;
                  text-align: left;
                  //font-weight: bold;
                  line-height:50px;
                }
              }
              .txt2Box{
                width: 100%;
                height: 103px;
                background: url("../assets/img/xiaomai/tg.png") no-repeat;
                margin-bottom: 30px;
                .txt2Item{
                  line-height: 30px;
                  font-size: 30px;
                  color: #fff;
                  text-align: left;
                  padding: 12px 30px 0 30px;
                }
                .txt2Item:first-child{
                  span:last-child{
                    color: #1BDDE3;
                  }
                }
                .txt2Item:last-child{
                  span:last-child{
                    color: #BAB350;
                  }
                }

              }
            }
          }
        }
        .center_r{
          flex: 1;
          height: 100%;
          margin-left: 100px;

          .center_r_A{
            width: 100%;
            height: 680px;
          }
          .center_r_B{
            width: 100%;
            flex: 1;
            .center_r_B_info{
              width: 100%;
              flex: 1;
              padding-top:30px;
              .info1{
                display: flex;
                flex-wrap: wrap;
                .info1Item{
                  width: 50%;
                  display: flex;
                  margin:20px 0;
                  display: flex;
                  align-items: center;
                  .imgBox{
                    width: 156px;
                    height: 108px;
                    position: relative;
                    flex-shrink: 0;
                    img{
                      width: 100%;
                      height: 100%;
                    }
                    span{
                      display: block;
                      position: absolute;
                      left: 0;
                      top: 0;
                      width: 100%;
                      height: 100%;
                      text-align: center;
                      font-size: 30px;
                      background: linear-gradient(to bottom,#FFFFFF 0%, #50E5D2 20%);
                      //background: linear-gradient(to right, #ff0000, #ffff00); /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
                      -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
                      -webkit-text-fill-color: transparent;/*给文字设置成透明*/
                    }
                  }
                  .txt{
                    //width: 130px;
                    color: #fff;
                    font-size: 28px;
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    i{font-size: 20px}
                  }
                }
                .info1Item:last-child{
                  .imgBox{
                    span{
                      background: linear-gradient(to bottom,#FFFFFF 0%, #E8E72B 20%);
                      -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
                      -webkit-text-fill-color: transparent;/*给文字设置成透明*/}
                  }
                  .txt{
                    color: #E8E72B;
                  }
                }
              }
              .info2{
                display: flex;
                flex-wrap: wrap;
                .info2Item{
                  width: 50%;
                  display: flex;
                  align-items: center;
                  margin-bottom: 20px;
                  img{
                    width: 120px;
                    height: 90px;
                  }
                  span{
                    color: #fff;
                    font-size: 26px;
                    margin-top: 20px;
                    text-align: left;
                  }
                }
              }
              .info3{
                background: url("../assets/img/xiaomai/yj1.png") no-repeat;
                color: #fff;
                width: 100%;
                height: 57px;
                line-height: 57px;
                margin: 50px 0 0;
                text-align: left;
                font-size: 30px;
                padding-left: 60px;
              }
            }
          }
        }
      }
    }
    .left,.right{
      width: 2173px;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      background: #071315;
    }
    .left{
      padding-left: 70px;
      padding-right: 70px;
      .leftBox1{
        width: 100%;
        height: 470px;
        display: flex;
        margin-top: -20px;
        padding-bottom: 10px;
      }
      .leftBox2{
        width: 100%;
        flex: 1;
        display: flex;
      }
      .leftBox3{
        height: 360px;
        display: flex;
        //.echartsBox{
        //  border: 1px solid;
        //}
      }
      .leftBox_item{
        flex: 1;
        height: 100%;
        //border: 1px solid;
        .leftTopInfo{
          width: 100%;
          flex: 1;
          display: flex;
          .echarts{
            height: 100%;
            flex: 1;
          }
        }
      }
    }
    .right{
      display: flex;
      flex-direction: column;
      padding: 0 70px;
      .rightInfo{
        display: flex;
        width: 100%;
        flex: 1;
        .right_l,.right_r{
          flex: 1;
          height: 100%;
        }
        .right_l{
          justify-content: space-between;
          .t_down {
            width: 100%;
            //height: 510px;
            // border: #3bf4be 1px solid;
            display: flex;
            flex-direction: column;
            .t_d_t_jz {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;

              h6 {
                width: 180px;
                height: 108px;
                font-size: 30px;
                color: #fff;
                text-align: left;
                line-height: 108px;
                // position: absolute;
                // left: 40px;
                // top: 0;
                letter-spacing: 5px;
                margin-right: 20px;
              }
              .srk {
                width: 706px;
                height: 108px;
                background: url("../assets/img/xiaomai/xzk.png") no-repeat;
                background-size: 100% 100%;
                // position: absolute;
                overflow: hidden;
                // right: 80px;
                // top: 0;
                font-size: 32px;
                color: #fff;
                line-height: 108px;
                text-align: left;
                letter-spacing: 4px;
                text-indent: 2em;
              }
            }

            .triangle {
              width: 0;
              height: 0;
              border-style: solid;
              position: absolute;
              border-width: 9px 9px 0 9px; /* 上下左右四个边框宽度 */
              border-color: #829297 transparent transparent transparent; /* 边框颜色：上红 下透明 左透明 右透明 */
              right: 110px;
              top: 22px;
              display: none;
            }

            .t_d_t {
              width: 100%;
              height: 108px;
              // margin: 20px 0;

              span {
                width: 40px;
                height: 45px;
                background: url("../assets/img/xiaomai/qy.png") no-repeat top
                center;
                background-size: 100% 100%;
                font-size: 30px;
                margin-right: 20px;
              }
            }
            .t_d_b {
              width: 100%;
              height: 108px;
              margin: 30px 0;

              span {
                width: 40px;
                height: 40px;
                background: url("../assets/img/xiaomai/pl.png") no-repeat top
                center;

                font-size: 30px;
                margin-right: 20px;
              }
            }
            .t_d_d {
              width: 100%;
              height: 108px;
              margin: 10px 0;
              position: relative;
              span {
                width: 49px;
                height: 46px;
                background: url("../assets/img/xiaomai/pz.png") no-repeat top
                center;
                background-size: 100% 100%;
                margin-right: 20px;
              }
            }
            .t_d_d1 {
              width: 100%;
              height: 108px;
              margin-top: 65px;
              // position: relative;
              display: flex;
              justify-content: center;
              align-items: center;

              h5 {
                width: 160px;
                height: 80px;
                font-size: 30px;
                color: #fff;
                text-align: left;
                line-height: 80px;
                letter-spacing: 4px;
                margin-right: 40px;
                margin-left: 0;
              }

              .t_d_d1_l {
                width: 395px;
                height: 100%;
                background: url("../assets/img/xiaomai/dkk.png") no-repeat
                top center;
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                // position: absolute;
                // left: 73px;
                .d1_xtb {
                  width: 56px;
                  height: 57px;
                  background: url("../assets/img/xiaomai/dk.png") no-repeat
                  top center;
                  background-size: 100% 100%;
                  // position: absolute;
                  // right: 22px;
                  // top: 10.5px;
                }
              }
              .t_d_d1_r {
                width: 393px;
                height: 100%;
                background: url("../assets/img/xiaomai/dkk.png") no-repeat
                top center;
                background-size: 100% 100%;
                display: flex;
                margin-left: 100px;
                justify-content: center;
                align-items: center;
                // position: absolute;
                // right: 80px;
                cursor: pointer;
                .d1_xtb {
                  width: 60px;
                  height: 57px;
                  background: url("../assets/img/xiaomai/sc.png") no-repeat
                  top center;
                  background-size: 100% 100%;
                  // position: absolute;
                  // right: 22px;
                  // top: 10.5px;
                }
              }
            }
          }
          .t_bottom{
            width: 100%;
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-end;
            //margin-top: 80px;
            .t_bottom_item{
              width: 478px;
              height: 274px;
              background: url("../assets/img/xiaomai/spk.png") no-repeat;
              padding: 5px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .right_r{
          justify-content: space-between;
          padding-left: 100px;
          .right_r_box1{
            height: 50%;
            padding: 0 30px;
            .l_t_d_m {
              width: 100%;
              height: 79px;
              display: flex;
              justify-content: center;
              .l_t_d_m_g {
                width: 230px;
                height: 79px;
                font-size: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: url("../assets/img/xiaomai/szjl.png") no-repeat top
                center;
                background-size: 100% 100%;
                cursor: pointer;
                margin: 5px 30px 0;
              }
              .l_t_d_m_g_cur {
                color: #23FFF2;
              }

              // .l_t_d_m_l {
              //   left: 166px;
              // }
              // .l_t_d_m_r {
              //   right: 166px;
              // }
            }
            .scrollTable {
              width: 100%;
              flex: 1;
              margin-top: 30px;
              ::v-deep .dv-scroll-board .rows .row-item {
                font-size: 30px;
                border: 4px solid transparent;
                //border-image: linear-gradient(to right, rgba(34,41,42,1), rgba(34,41,42,0)) 30 round;
                border-left: 0;
                border-bottom: 0;
                border-image: linear-gradient(to right,rgba(34,41,42,0) 10%, rgba(34,41,42,1) 20%,rgba(34,41,42,1) 50%,rgba(34,41,42,1) 80%,  rgba(34,41,42,0)) 4;
              }
            }
          }
          .right_r_box2{
            width: 100%;
            flex: 1;
            //padding-left: 100px;
            padding-top: 60px;
            justify-content: space-between;
            h4{
              width: 100%;
              height: 50px;
              background: url("../assets/img/xiaomai/mx.png") no-repeat left bottom;
              line-height: 40px;
              font-size: 30px;
              color: #fff;
              text-align: left;
              padding-left: 40px;
            }
            .right_r_box2_item1{
              .txt1{
                font-size: 26px;
                color: #fff;
                text-align: left;
                line-height: 40px;
                padding: 20px 30px;
                text-indent: 2em;
              }
            }
            .right_r_box2_item2{
              //margin-top: 30px;
              .txt2{
                width: 100%;
                flex: 1;
                display: flex;
                flex-wrap:wrap;
                justify-content: center;
                //padding-right: 100px;
                span{
                  display: block;
                  width: 356px;
                  height: 73px;
                  line-height: 73px;
                  background:#08292C ;
                  color: #fff;
                  font-size: 26px;
                  text-align: left;
                  margin: 20px 50px;
                  padding: 0 30px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.popBg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all 0.5s ease-out;
  .faCon {
    width: 50%;
    height: 70%;
    position: absolute;
    top: 15%;
    left: 25%;
    background: #102130;
    // border: 2px solid;
    border: 2px solid #16616a;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 50px;
    box-sizing: border-box;
    align-items: center;
    overflow-y: auto;
    .close {
      color: rgba(255, 255, 255, 0.8);
      font-size: 60px;
      position: absolute;
      top: 20px;
      right: 26px;
      cursor: pointer;
    }
    .faInfo {
      width: 90%;
      flex: 1;
      margin-top: 30px;
      font-size: 14px;
      .moxing{
        line-height: 50px;
        line-height: 52px;
        h2{
          font-size: 40px;
          color: #0CB3A5;
        }
        h3{
          font-size: 36px;
          color: #0CB3A5;
          text-align: left;
          margin: 10px 0;
        }
        p{
          text-align: left;
          font-size: 30px;
          color: rgba(255,255,255,.8);
        }
      }
    }

  }
}

::v-deep .dv-scroll-board .header {
  display: flex;
  flex-direction: row;
  font-size: 30px;
  background: url("../assets/img/xiaomai/nq.png") no-repeat top center;
  background-size: 100% 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
}
::v-deep .dv-scroll-board .rows .row-item {
  font-size: 30px;
}
::v-deep .el-tabs__nav-wrap.is-scrollable{
  padding: 0 100px;
}
::v-deep .el-tabs__active-bar{
  bottom: 79px;
}


@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
     animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
   
  }
}
.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 0px;
  left: 0;
  width: 10%;
  height: 1px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 1px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: -1px;
  right: -100%;
  width: 20%;
  height: 1px;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 0px;
  width: 1px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
0% {
      transform: rotate(0deg);
  }

100% {
  transform: rotate(-360deg);
}
}

@keyframes animate1 {
0% {
    left: -50%;
}

50%,
100% {
    left: 100%;
}
}

@keyframes animate2 {
0% {
    top: -100%;
}

50%,
100% {
    top: 100%;
}
}
@keyframes animate3 {
0% {
    right: -100%;
    height: 3px;
}

50%,
100% {
    height: 2px;
    right: 100%;
}
}
@keyframes animate4 {
0% {
    bottom: -100%;
}

50%,
100% {
    bottom: 100%;
}
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
